import React, { Component } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";
import ProductionOrderProductsTable from "./ProductionOrderProductsTable";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import instance from "@/store/actions/instance";

class ProductionOrderInvoice extends Component {
  printIframe = async () => {
    const { t, selectedOrder } = this.props;
    this.setState({ invoicesLoading: true });
    try {
      const invoice = await instance.get(
        `production/invoice/${selectedOrder.id}`
      );
      const iframe = document.frames
        ? document.frames["printingIframe"]
        : document.getElementById("printingIframe");
      iframe.srcdoc = invoice.data;
    } catch (e) {
      console.error(e);
      message.error(t("SomethingWentWrong"));
      this.setState({ invoicesLoading: false });
      return false;
    }
  };
  render() {
    const { t, selectedOrder, products, isViewOnly } = this.props;

    return (
      <div
        className="jumbotron bg-white p-0 mt-4"
        style={{ paddingTop: 20, minWidth: 320 }}
      >
        <iframe
          id="printingIframe"
          style={{ display: "none" }}
          title="Receipt"
          onLoad={() => {
            const iframe = document.frames
              ? document.frames["printingIframe"]
              : document.getElementById("printingIframe");
            if (!this.state.invoicesLoading || !iframe.srcdoc) return;

            const iframeWindow = iframe.contentWindow || iframe;
            iframe.focus();
            iframeWindow.print();
            this.setState({ invoicesLoading: false });
          }}
        />
        <div className="my-3 " style={{ display: "flex", gap: 12 }}>
          <Button
            onClick={this.printIframe}
            icon={<PrinterOutlined style={{ fontSize: 19 }} />}
          >
            {t("Print")}
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Tracking Code")}:
            </span>
            <span>{selectedOrder.tracking_id}</span>
          </div>
          {selectedOrder.status == "Cancelled" ? (
            <div style={{ display: "flex" }}>
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Cancelled date")}:
              </span>

              <span>
                {selectedOrder.cancelled_date
                  ? `${moment(selectedOrder.cancelled_date).format(
                      "MMM Do YYYY - h:mm a"
                    )} - ${t("by")} ${selectedOrder.cancelled_by__username}`
                  : "-"}
              </span>
            </div>
          ) : (
            <>
              <div style={{ display: "flex" }}>
                <span
                  style={{
                    fontWeight: "bold",
                    minWidth: 150,
                  }}
                >
                  {t("Placed")}:
                </span>

                <span>
                  {selectedOrder.created
                    ? `${moment(selectedOrder.created).format(
                        "MMM Do YYYY - h:mm a"
                      )} - ${t("by")} ${selectedOrder.created_by__username}`
                    : "-"}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    minWidth: 150,
                  }}
                >
                  {t("Completed Date")}:
                </span>
                <span>
                  {selectedOrder.completed_date
                    ? `${moment(selectedOrder.completed_date).format(
                        "MMM Do YYYY - h:mm a"
                      )} - ${t("by")} ${selectedOrder.completed_by__username}`
                    : "-"}
                </span>
              </div>
            </>
          )}
          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Branch")}:
            </span>

            <span>{selectedOrder.branch__name}</span>
          </div>
        </div>
        <ProductionOrderProductsTable
          setEditMode={this.props.setEditMode}
          setProducts={this.props.setProducts}
          editMode={this.props.editMode}
          products={products}
          selectedOrder={selectedOrder}
          isViewOnly={isViewOnly}
        />
        {selectedOrder.notes && (
          <>
            <h6>Note:</h6>
            <p>{selectedOrder.notes}</p>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ProductionOrderInvoice));
